import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

/**
 * Helper Function to validate if a number is decimal upto some points of precision
 */
export const isDecimalNumber = (value: any, precision = 2, allowZero = true) => {
    if (typeof value === "string") {
        return false;
    }

    if (allowZero && value === 0) {
        return true;
    }

    const result = value - Math.floor(value);

    const isDecimal = String(result).length > 1;
    const formattedNumberToValidate = isDecimal ? String(value).split(".")[1] : result;

    return value && String(formattedNumberToValidate).length <= precision;
};

interface FormikErrors {
    [key: string]: any;
}

const getFieldErrorNames = (formikErrors: FormikErrors) => {
    const transformObjectToDotNotation = (object: FormikErrors, prefix = "", result: any[] = []) => {
        for (const key of Object.keys(object)) {
            const value = object[key];
            if (!value) continue;

            const nextKey = prefix ? `${prefix}.${key}` : key;
            if (typeof value === "object") {
                transformObjectToDotNotation(value, nextKey, result);
            } else {
                result.push(nextKey);
            }
        }

        return result;
    };

    return transformObjectToDotNotation(formikErrors);
};

export const ScrollToFieldError = () => {
    const [localSubmitCount, setSubmitCount] = useState(0);
    const { submitCount, isValid, errors } = useFormikContext();

    useEffect(() => {
        if (isValid) {
            return;
        }

        if (submitCount === localSubmitCount) {
            setSubmitCount(submitCount);
            return;
        }

        const fieldErrorNames = getFieldErrorNames(errors);
        if (fieldErrorNames.length <= 0) {
            return;
        }

        const element = document.querySelector(`[name='${fieldErrorNames[0]}']`);

        if (!element) {
            return;
        }

        // Scroll to first known error into view
        element.scrollIntoView({ behavior: "smooth", block: "center" });
    }, [submitCount, isValid]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};

export const removeNonBreakingSpaces = (content: string) => {
    return content.replace(/&amp;nbsp;|&nbsp;/g, " ");
};

export const formatTextWithLineBreaks = (content: string) => {
    const textWithBreaks = content.replace(/\n/g, "<br>");

    return `<p>${textWithBreaks}</p>`;
};

export const isMongoID = (id: string) => {
    const mongoIDRegex = /^[a-f\d]{24}$/i;
    return mongoIDRegex.test(id);
};
